<template>
    <v-dialog v-model="mostrar" persistent fullscreen transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar color="blue-grey" dark class="px-2">
                <v-toolbar-title>
                    <h1 class="subtitle-1">{{ expediente ? !ver ? "Modificar" : "Consultar" : "Crear" }} Expediente</h1>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn x-small icon fab @click="$emit('cancelar')">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-form ref="form" v-model="valid">
                <v-card-text class="v-card-padding">
                    <section class="pl-3">
                        <v-row align="center">
                            <v-col class="blue-grey rounded" cols="6" sm="4">
                                <span class="subtitle-2">Unidad Administrativa</span>
                            </v-col>
                            <v-col cols="6" sm="4">
                                <v-autocomplete v-model="selectedDependencia" :items="dependencias" solo dense
                                    :readonly="ver" :filter="filter" hide-details="auto" return-object
                                    item-text="nombre"></v-autocomplete>
                            </v-col>
                            <v-col>
                                <v-text-field outlined dense required hide-details disabled
                                    :value="selectedDependencia && selectedDependencia.codigo" />
                            </v-col>
                        </v-row>
                        <v-row align="center">
                            <v-col class="blue-grey rounded" cols="6" sm="4">
                                <span class="subtitle-2">Serie</span>
                            </v-col>
                            <v-col cols="6" sm="4">
                                <v-autocomplete v-model="selectedSerie" :items="series" solo dense hide-details="auto"
                                    :readonly="ver" :loading="loadingSeries" :filter="filter" return-object
                                    item-text="nombre"></v-autocomplete>
                            </v-col>
                            <v-col>
                                <v-text-field outlined dense required hide-details disabled
                                    :value="selectedSerie && selectedSerie.numero" />
                            </v-col>
                        </v-row>
                        <v-row align="center">
                            <v-col class="blue-grey rounded" cols="6" sm="4">
                                <span class="subtitle-2">Subserie</span>
                            </v-col>
                            <v-col cols="6" sm="4">
                                <v-autocomplete v-model="selectedSubSerie" :items="subseries" solo dense :readonly="ver"
                                    hide-details="auto" :loading="loadingSubSeries" :filter="filter" return-object
                                    item-text="nombre"></v-autocomplete>
                            </v-col>
                            <v-col>
                                <v-text-field outlined dense required hide-details disabled
                                    :value="selectedSubSerie && selectedSubSerie.numero" />
                            </v-col>
                        </v-row>
                        <v-row align="center" v-if="selectedSerie && selectedSerie.seccion">
                            <v-col class="blue-grey rounded" cols="4">
                                <span class="subtitle-2">Sección</span>
                            </v-col>
                            <v-col>
                                <v-text-field disabled outlined dense required hide-details="auto"
                                    :value="selectedSerie && selectedSerie.seccion" />
                            </v-col>
                        </v-row>
                    </section>
                    <section>
                        <span class="blue-grey rounded rounded-b-0 d-flex justify-center subtitle-2">Descripción</span>
                        <v-textarea v-model="descripcion" outlined class="rounded-t-0" :clearable="!ver" :readonly="ver"
                            clear-icon="mdi-close-circle" no-resize hide-details="auto" required :rules="rules">
                        </v-textarea>
                    </section>
                    <section>
                        <v-row no-gutters style="gap:1rem">
                            <v-col>
                                <span class="blue-grey rounded rounded-b-0 d-flex justify-center subtitle-2">Valores
                                    documentales</span>
                                <v-row no-gutters class="text-center">
                                    <v-col class="blue-grey v-col-stroke"><span>A</span></v-col>
                                    <v-col class="blue-grey v-col-stroke"><span>L</span></v-col>
                                    <v-col class="blue-grey v-col-stroke"><span>F/C</span></v-col>
                                </v-row>
                                <v-row no-gutters class="text-center">
                                    <v-col><v-text-field outlined dense hide-details="auto" class="rounded-0"
                                            :value="selectedSubSerie && valoresDocumentales(selectedSubSerie.valores.primarios, 'A')"
                                            disabled></v-text-field></v-col>
                                    <v-col><v-text-field outlined dense hide-details="auto" class="rounded-0"
                                            :value="selectedSubSerie && valoresDocumentales(selectedSubSerie.valores.primarios, 'L')"
                                            disabled></v-text-field></v-col>
                                    <v-col><v-text-field outlined dense hide-details="auto" class="rounded-0"
                                            :value="selectedSubSerie && valoresDocumentales(selectedSubSerie.valores.primarios, 'F/C')"
                                            disabled></v-text-field></v-col>
                                </v-row>
                            </v-col>
                            <v-col>
                                <span class="blue-grey rounded rounded-b-0 d-flex justify-center subtitle-2">Plazo de
                                    conservación</span>
                                <v-row no-gutters class="text-center">
                                    <v-col class="blue-grey v-col-stroke"><span>AT</span></v-col>
                                    <v-col class="blue-grey v-col-stroke"><span>AC</span></v-col>
                                    <v-col class="blue-grey v-col-stroke"><span>Total</span></v-col>
                                </v-row>
                                <v-row no-gutters class="text-center">
                                    <v-col><v-text-field outlined dense hide-details="auto" class="rounded-0" disabled
                                            :value="selectedSubSerie && selectedSubSerie.plazoAT"></v-text-field></v-col>
                                    <v-col><v-text-field outlined dense hide-details="auto" class="rounded-0" disabled
                                            :value="selectedSubSerie && selectedSubSerie.plazoAC"></v-text-field></v-col>
                                    <v-col><v-text-field outlined dense hide-details="auto" class="rounded-0" disabled
                                            :value="selectedSubSerie && selectedSubSerie.plazoAC + selectedSubSerie.plazoAT"></v-text-field></v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </section>
                    <section>
                        <v-row no-gutters style="gap:1rem">
                            <v-col cols="6" sm="4">
                                <span
                                    class="blue-grey rounded rounded-b-0 d-flex justify-center subtitle-2">Clasificación
                                    de
                                    la información</span>
                                <v-row no-gutters class="text-center">
                                    <v-col class="blue-grey v-col-stroke"><span>Confidencial</span></v-col>
                                    <v-col class="blue-grey v-col-stroke"><span>Reservada</span></v-col>
                                </v-row>
                                <v-row no-gutters class="text-center">
                                    <v-col><v-text-field outlined dense hide-details="auto" class="rounded-0"
                                            :value="selectedSubSerie && clasificacionInformacion(selectedSubSerie.clasificacion.libre, false)"
                                            disabled></v-text-field></v-col>
                                    <v-col><v-text-field outlined dense hide-details="auto" class="rounded-0"
                                            :value="selectedSubSerie && clasificacionInformacion(selectedSubSerie.clasificacion.protegida, true)"
                                            disabled></v-text-field></v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="6" sm="4">
                                <span class="blue-grey rounded rounded-b-0 d-flex justify-center subtitle-2">Disposición
                                    documental</span>
                                <v-row no-gutters class="text-center">
                                    <v-col class="blue-grey v-col-stroke"><span>Baja</span></v-col>
                                    <v-col class="blue-grey v-col-stroke"><span>A Histórico</span></v-col>
                                </v-row>
                                <v-row no-gutters class="text-center">
                                    <v-col><v-text-field outlined dense hide-details="auto" class="rounded-0"
                                            :value="selectedSubSerie && clasificacionInformacion(selectedSubSerie.destinoFinal.baja, true)"
                                            disabled></v-text-field></v-col>
                                    <v-col><v-text-field outlined dense hide-details="auto" class="rounded-0"
                                            :value="selectedSubSerie && clasificacionInformacion(selectedSubSerie.destinoFinal.archivoHistorico, false)"
                                            disabled></v-text-field></v-col>
                                </v-row>
                            </v-col>
                            <v-col>
                                <span class="blue-grey rounded rounded-b-0 d-flex justify-center subtitle-2">Periodo de trámite</span>
                                <v-row no-gutters class="text-center">
                                    <v-col class="blue-grey v-col-stroke"><span>Apertura</span></v-col>
                                    <v-col class="blue-grey v-col-stroke"><span>Cierre</span></v-col>
                                </v-row>
                                <v-row no-gutters class="text-center">
                                    <v-col>
                                        <v-menu
                                            v-model="menu"
                                            :disabled="ver"
                                            :close-on-content-click="false"
                                            max-width="290"
                                            >
                                            <template v-slot:activator="{ on }">
                                            <v-text-field
                                                :value="fechaApertura"
                                                v-on="on"
                                                outlined dense hide-details="auto"
                                                readonly class="rounded-0" required
                                                :rules="rules"
                                            ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                color="blue-grey darken-2"
                                                v-model="fechaApertura"
                                                locale="es"
                                                @change="menu = false"
                                                no-title 
                                                ></v-date-picker>
                                            </v-menu>
                                        </v-col>
                                    <v-col>
                                        <v-menu 
                                            v-model="menu2"
                                            :disabled="ver"
                                            :close-on-content-click="false"
                                            max-width="290"
                                            >
                                            <template v-slot:activator="{ on }">
                                            <v-text-field
                                                :value="fechaCierre"
                                                v-on="on"
                                                outlined dense hide-details="auto"
                                                readonly class="rounded-0" 
                                            ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                color="blue-grey darken-2"
                                                v-model="fechaCierre"
                                                locale="es"
                                                @change="menu2 = false"
                                                no-title 
                                                :min="fechaApertura"
                                                ></v-date-picker>
                                            </v-menu>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </section>
                    <section>
                        <v-row no-gutters style="gap:1rem">
                            <v-col>
                                <span class="blue-grey rounded rounded-b-0 d-flex justify-center subtitle-2">Soporte
                                    Documental</span>
                                <v-row no-gutters class="text-center">
                                    <v-col
                                        class="blue-grey v-col-stroke d-flex justify-center align-center"><span>Físico</span></v-col>
                                    <v-col
                                        class="d-flex justify-center align-center v-col-border py-1"><v-simple-checkbox
                                            :disabled="ver" v-model="soporteDocumental.fisico"
                                            @input="soporteDocumental.electronico = !soporteDocumental.electronico"
                                            :ripple="false"></v-simple-checkbox></v-col>
                                    <v-col
                                        class="blue-grey v-col-stroke d-flex justify-center align-center"><span>Electrónico</span></v-col>
                                    <v-col class="d-flex justify-center align-center  v-col-border"><v-simple-checkbox
                                            v-model="soporteDocumental.electronico"
                                            @input="soporteDocumental.fisico = !soporteDocumental.fisico"
                                            :ripple="false" :disabled="ver"></v-simple-checkbox></v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col class="blue-grey v-col-stroke d-flex justify-center align-center"><span>No
                                            Folios</span></v-col>
                                    <v-col><v-text-field :disabled="!soporteDocumental.fisico" v-model.number="soporteDocumental.noFolios" outlined dense
                                            type="number" hide-spin-buttons :readonly="ver" hide-details="auto"
                                            class="rounded-0" :rules="numberRules"></v-text-field></v-col>
                                    <v-col
                                        class="blue-grey v-col-stroke d-flex justify-center align-center"><span>Archivos</span></v-col>
                                    <v-col><v-text-field :disabled="!soporteDocumental.electronico" v-model.number="soporteDocumental.archivos" outlined dense
                                            :rules="numberRules" type="number" hide-spin-buttons
                                            :readonly="ver" hide-details="auto"
                                            class="rounded-0"></v-text-field></v-col>
                                </v-row>
                                <v-row no-gutters class="text-center">
                                    <v-col class="blue-grey v-col-stroke d-flex justify-center align-center"><span>No
                                            Tomos</span></v-col>
                                    <v-col><v-text-field :disabled="!soporteDocumental.fisico" v-model.number="soporteDocumental.noTomos" outlined dense
                                            :rules="numberRules" type="number" hide-spin-buttons
                                            :readonly="ver" hide-details="auto"
                                            class="rounded-0"></v-text-field></v-col>
                                    <v-col
                                        class="blue-grey v-col-stroke d-flex justify-center align-center"><span>Tamaño</span></v-col>
                                    <v-col><v-text-field :disabled="!soporteDocumental.electronico" v-model.number="soporteDocumental.tamano" outlined dense
                                            :rules="numberRules" type="number" hide-spin-buttons
                                            :readonly="ver" hide-details="auto"
                                            class="rounded-0"></v-text-field></v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </section>
                    <section :class="ver ? 'pb-8' : ''">
                        <span
                            class="blue-grey rounded rounded-b-0 d-flex justify-center subtitle-2">Observaciones</span>
                        <v-textarea v-model="observaciones" outlined class="rounded-t-0" :clearable="!ver"
                            :readonly="ver" clear-icon="mdi-close-circle" no-resize hide-details="auto">
                        </v-textarea>
                    </section>
                    <section v-if="!ver" class="btn-gap">
                        <v-row no-gutters justify="end" class="v-row-buttons-gap">
                            <v-btn outlined @click="$emit('cancelar')">Cancelar</v-btn>
                            <v-btn color="blue-grey" dark @click="guardar">Guardar</v-btn>
                        </v-row>
                    </section>
                </v-card-text>
            </v-form>
        </v-card>
    </v-dialog>
</template>
<script>

import { getDependencias, getSeries, getSubSeries, addExpediente, modificarExpediente } from './expediente.service';

export default {
    name:"agregarExpediente",
    props: ['mostrar', 'expediente', 'ver'],
   watch: {
        selectedDependencia: function (dependencia) {
            this.loadingSeries = true;
            this.series = this.getSeries(dependencia.subseries);
            if(this.iteration < 2 && this.expediente){
                this.selectedSerie = this.series.find((serie) => serie._id == this.expediente.serie._id);
                this.iteration++;
            }
            else this.selectedSerie = this.series[0] || null;
            this.loadingSeries = false;
        },
        selectedSerie: function () {
            this.loadingSubSeries = true;
            this.subseries = this.getSubSeries();
            if(this.iteration < 2 && this.expediente){
                this.selectedSubSerie = this.subseries.find((subserie) => subserie._id == this.expediente.subserie._id);
                this.iteration++;
            }
            else this.selectedSubSerie = this.subseries[0] || null;
            this.loadingSubSeries = false;
        }
    },
    data: () => ({
        valid: false,
        repoSeries: [],
        repoSubSeries: [],
        loadingSeries: false,
        loadingSubSeries: false,
        menu: false,
        menu2: false,
        dependencias: [],
        series: [],
        subseries: [],
        selectedDependencia: null,
        selectedSerie: null,
        selectedSubSerie: null,
        descripcion: '',
        soporteDocumental: {
            fisico: false,
            electronico: true,
            noFolios: 0,
            noTomos: 0,
            archivos: 0,
            tamano: 0
        },
        fechaApertura: '',
        fechaCierre: '',
        observaciones: '',
        rules: [
            value => !!value || 'Campo requerido',
        ],
        numberRules: [
            value => Number.isInteger(value) || 'Debe ser un número',
            value => value >= 0 || 'Debe ser mayor o igual a 0'
        ],
        loading:false,
        iteration:0
    }),
    async created() {
        try {
            const serverResponse = await getDependencias();
            const serverResponseSeries = await getSeries();
            const serverResponseSubSeries = await getSubSeries();

            if (!serverResponse.ok) throw new Error(serverResponse.mensaje);
            if (!serverResponseSeries.ok) throw new Error(serverResponseSeries.mensaje);
            if (!serverResponseSubSeries.ok) throw new Error(serverResponseSubSeries.mensaje);

            this.repoSeries = serverResponseSeries.series;
            this.repoSubSeries = serverResponseSubSeries.subSeries;
            this.dependencias = serverResponse.dependencias.filter((dependencia) => dependencia.subseries);

            this.selectedDependencia = this.dependencias[0];
            if (this.expediente) {
                this.selectedDependencia = this.dependencias.find((dependencia) => dependencia._id == this.expediente.unidadAdministrativa._id);
                this.selectedSerie = this.repoSeries.find((serie) => serie._id == this.expediente.serie._id);
                this.selectedSubSerie = this.repoSubSeries.find((subserie) => subserie._id == this.expediente.subserie._id);
                this.descripcion = this.expediente.descripcion;
                this.observaciones = this.expediente.observaciones;
                this.fechaApertura = new Date(this.expediente.fechaApertura).toISOString().substr(0, 10);
                this.fechaCierre = this.expediente.fechaCierre? new Date(this.expediente.fechaCierre).toISOString().substr(0, 10): ''
                this.soporteDocumental = {
                    fisico: this.expediente.soporteDocumental == 'PAPEL',
                    electronico: this.expediente.soporteDocumental == 'ELECTRONICO',
                    noFolios: this.expediente.folios,
                    noTomos: this.expediente.tomos,
                    archivos: this.expediente.archivos,
                    tamano: this.expediente.tamanio
                }
            }

        } catch (error) {

            this.$notificarError(error);
        }
    },
    methods: {
        async guardar() {
            this.$refs.form.validate();
            const expediente = {
                //ids
                unidadAdministrativa: this.selectedDependencia._id,
                serie: this.selectedSerie._id,
                subserie: this.selectedSubSerie._id,
                //strings
                descripcion: this.descripcion,
                observaciones: this.observaciones,
                fechaApertura: this.fechaApertura,
                fechaCierre: this.fechaCierre,
                soporteDocumental: this.soporteDocumental.fisico ? 'PAPEL' : 'ELECTRONICO',
                folios: this.soporteDocumental.fisico ? this.soporteDocumental.noFolios : 0,
                tomos: this.soporteDocumental.fisico ? this.soporteDocumental.noTomos : 0,
                archivos: this.soporteDocumental.electronico ? this.soporteDocumental.archivos : 0,
                tamanio: this.soporteDocumental.electronico ?this.soporteDocumental.tamano : 0

            }
            try {
                //esta validacion es innecesaria
                if (!this.valid) {
                    throw new Error('Por favor, llene todos los campos');
                }
                this.loading=true;
                const repoToUse = this.expediente ? modificarExpediente : addExpediente;
                const serverResponse = await repoToUse(this.$route.params.id, expediente);
                if (!serverResponse.ok) throw new Error(serverResponse.mensaje);
                this.loading=false
                this.$emit('guardar', { ...serverResponse.expediente, unidadAdministrativa: this.selectedDependencia, serie: this.selectedSerie, subserie: this.selectedSubSerie });
                this.$emit('cancelar');
                this.$notify({ group: 'gral_notif', type: "success", duration: 1500, speed: 500, text: "Expediente guardado correctamente" });
            } catch (error) {
                this.loading=false;
                this.$notificarError(error.message);
            }
        },
        filter(item, queryText, itemText) {
            const textOne = itemText.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "");
            const textTwo = queryText.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "");
            return textOne.indexOf(textTwo) > -1;
        },
        valoresDocumentales(arregloValores, char) {
            if (!arregloValores || !char) return ""
            return arregloValores.includes(char) ? "X" : ""
        },
        clasificacionInformacion(clasificacion, type) {
            if (!type) return clasificacion != type ? "X" : ""
            return clasificacion == type ? "X" : ""
        },
        getSubSeries() {
            return this.repoSubSeries.filter((subserie) => this.selectedDependencia.subseries.includes(subserie._id) && this.selectedSerie._id == subserie.serie);
        },
        getSeries(subseries) {
            if (!subseries) return []
            const subseriesArray = this.repoSubSeries.filter((subserie) => this.selectedDependencia.subseries.includes(subserie._id));
            return subseriesArray.reduce((acc, subserie) => {
                const serie = this.repoSeries.find((serie) => serie._id == subserie.serie);
                if (!acc.includes(serie)) { acc.push(serie); }
                return acc;
            }, []);
        }

    }

}
</script>

<style scoped>
.v-row-gap {
    gap: 1rem;
}

.v-row-buttons-gap {
    gap: .2rem;

}

.v-col-stroke {
    border-left: .5px solid #919191fa !important;
    border-top: .5px solid #919191fa !important;
    border-right: .5px solid #919191fa !important;
}

.v-col-border {
    border: .5px solid #919191fa !important;
}

section {
    margin-top: 2rem;
}

.btn-gap {
    padding-bottom: 2rem;
}

span {
    color: rgb(229, 229, 229);
}

@media screen and (max-width: 600px) {
    .v-card-padding {
        padding: 0 1rem !important;
    }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
    .v-card-padding {
        padding: 0 2rem !important;
    }
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
    .v-card-padding {
        padding: 0 3rem !important;
    }
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
    .v-card-padding {
        padding: 0 5rem !important;
    }
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
    .v-card-padding {
        padding: 0 15rem !important;
    }
}
</style>
